import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-image-uploader',
  templateUrl: './image-uploader.component.html',
  styleUrls: ['./image-uploader.component.css']
})
export class ImageUploaderComponent implements OnInit {

  @ViewChild('fileInput') fileInput: ElementRef;

  @Output() onChooseFile:EventEmitter<any> = new EventEmitter()

  clickEventsubscription: Subscription;

  @Output() onChooseImagesCallback: EventEmitter<any> = new EventEmitter()

  constructor(
    private sharedService: SharedService,
    
  ) {
    this.clickEventsubscription = this.sharedService.getClickEvent().subscribe(() => {
      this.fileInput.nativeElement.click()
    })
  }


  ngOnInit(): void {
    console.log("Init");
  }

  fileChangeEvent(event: any): void {
    const file = event.target.files[0];
    this.onChooseFile.emit(file)
  }

 



}
